// Constants
import { StepsProps } from 'antd';

import { TDocumentTypeId } from 'modules/users/resources/getUserDocuments/getUserDocuments.types';
import { TKycRelationTypes } from './kyc.types';
import { TKycMessages } from './message.types';

export const PROVIDERS = {
  UBBLE: 'ubble',
  GREENPOINT: 'greenpoint',
  IDNOW_VIDEO_CONF: 'idnowVideoConf',
  IDNOW_QES: 'idnowQES',
  CREDIT_SAFE: 'creditsafe',
} as const;
export type TProviders = TValueOf<typeof PROVIDERS>;

export const SUMMARY_STEP_IDS = {
  KYC: '10122024',
  KYB: '20233025',
} as const;

export const KYC_STEPS_KEYS = {
  GENERAL_INFORMATION: 'GENERAL_INFORMATION',
  ID_DOCUMENTS: 'ID_DOCUMENTS',
  ID_INFORMATIONS: 'ID_INFORMATIONS',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  TRANSACTIONS: 'TRANSACTIONS',
  ADDITIONAL_DOCUMENT: 'ADDITIONAL_DOCUMENT',
  BUSINESS_LEGAL_ENTITY: 'BUSINESS_LEGAL_ENTITY',
  BUSINESS_USER: 'BUSINESS_USER',
  SUMMARY: 'SUMMARY',
  KYB_SUMMARY: 'KYB_SUMMARY',
} as const;

// Types

export type TKycStepKeys = TValueOf<typeof KYC_STEPS_KEYS>;

export interface IKycStepApiResponse {
  id: number;
  startedAt: string | null;
  endedAt: string | null;
  readonly: boolean;
  checklistStep: {
    name: string;
    type: TKycStepKeys;
    thirdPartyProvider: TProviders | null;
    documentTypeIds: TDocumentTypeId[] | null;
    position: string;
  };
  user: {
    userId: number;
    parentUserId: number | null;
    relationType: TKycRelationTypes | null;
  };
  messages: TKycMessages;
}

export type TFetchKycStepsApiResponse = IKycStepApiResponse[];

export type TAntStepItem = NonNullable<StepsProps['items']>[number];

export type TStepperItem = {
  id: string;
  disabled?: TAntStepItem['disabled'];
  status: TAntStepItem['status'];
};

export type TInternalStepperItem = TStepperItem & {
  userId: number | null;
  type: TKycStepKeys;
  messages: TKycMessages;
  documentTypeIds: TDocumentTypeId[] | null;
  thirdPartyProvider?: TProviders | null;
  isChildStep: boolean;
  parentUserId: number | null;
  relationType: TKycRelationTypes | null;
  readonly: boolean;
};
